import {
	Component,
	HostListener,
	inject,
	OnDestroy,
	OnInit,
	TemplateRef,
	ViewChild,
} from '@angular/core';
import {
	FormularioRelatorio,
	INPUTS_RELATORIOS,
} from '@home/submodulos/dados-meteorologicos/interfaces/tipos-relatorios';
import { Validators } from '@angular/forms';
import { PostosRelatorios } from '@home/submodulos/dados-meteorologicos/interfaces/tabela-relatorio';
import { Estacao } from '@home/submodulos/dados-meteorologicos/interfaces/filtros-opcoes';
import { Select } from '@layout/interfaces/select';
import {
	criarCanvasInterpolacao,
	InterpolacaoCanvasBounds,
} from '@utils/interpolacao/interpolacao';
import { GeoJSON } from '@shared/interfaces/geometry';
import { HttpClient } from '@angular/common/http';
import { Polygon, GeoJsonObject } from 'geojson';
import * as Leaflet from 'leaflet';
import { Iapm } from '@home/submodulos/dados-meteorologicos/interfaces/iapm';
import { GraficosPrecipitacaoService } from '@home/submodulos/dados-meteorologicos/services/graficos-precipitacao.service';
import {
	endOfMonth,
	format,
	formatISO,
	startOfMonth,
	subMonths,
} from 'date-fns';
import { VariavelMeteorologica } from '@utils/interpolacao/intepolacao-parametros';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import {
	alinharDado,
	baixarEAbrirPDF,
	isNuloOuUndefined,
	obter_erro_request,
	verificaSePDFEAdicionaNaTabela,
} from '@utils';
import { ToastrService } from 'ngx-toastr';
import html2canvas from 'html2canvas';
import ptBrLocale from 'date-fns/locale/pt-BR';
import * as pdfseira from '@utils/pdf-seira';
import { RelatoriosService } from '../../../services';
import * as ExcelTable from 'mr-excel';
import { DocumentExporter } from '@utils/document-exporter';
import { DateTimeUtils } from '@utils/datetime-util';
import { numberToBrNumberTables } from '../../../../../../../shared/utils/index';
import { MapaInterpolacaoComponent } from '../../../submodulos/monitoramento/pages/variaveis/componentes/mapa-interpolacao/mapa-interpolacao.component';
import { corrigeDuplicacaoNome } from '../../../utils';
import { NumberUtils } from '@utils/number-utils';
import { IapmComStrings } from './iapm-com-strings';
import Position = GeoJSON.Position;
import FeatureCollection = GeoJSON.FeatureCollection;

@Component({
	selector: 'seira-mapa-iapm',
	templateUrl: './mapa-iapm.component.html',
	styleUrls: ['./mapa-iapm.component.scss'],
})
export class MapaIapmComponent implements OnInit, OnDestroy {
	mapa!: MapaInterpolacaoComponent;
	@ViewChild(MapaInterpolacaoComponent, { static: false })
	set mapaInterpolacao(mapa: MapaInterpolacaoComponent) {
		if (mapa) {
			this.mapa = mapa;
		}
	}
	@ViewChild('legendaMapaMobile') legendaMapaMobile!: TemplateRef<any>;
	interpolacaoPrecipitacao?: InterpolacaoCanvasBounds;
	interpolacaoIAPM?: InterpolacaoCanvasBounds;
	carregando = true;
	valoresPrecipitacao: Iapm[] = [];
	valoresIAPM: Iapm[] = [];
	inputs = inject(INPUTS_RELATORIOS);
	postos: PostosRelatorios[] = [];
	estacoes: Estacao[] = [];
	microrregioes: Select[] = [];
	medicoes: Iapm[] = [];
	regiao?: Position[][];
	private coordOverlayEl?: HTMLDivElement;
	private coordOverlayCleanup?: () => void;
	private compassOverlayEl?: HTMLDivElement;
	private compassOverlayCleanup?: () => void;
	private pbGeo?: GeoJsonObject;
	private isExporting = false;
	private readonly exportScale = 2;
	private readonly exportDesktopWidth = 993;
	private readonly exportMapHeight = 500;
	private contornoPaneName = 'contorno-pane';
	private maskPaneName = 'mask-pane';
	private outlineLayer?: Leaflet.Layer;
	private maskLayer?: Leaflet.Layer;
	private readonly coordenadasRef: {
		eixoVertical: Array<{ lat: number; label: string }>;
		eixoHorizontal: Array<{ lng: number; label: string }>;
	} = {
		eixoVertical: [
			{ lat: -5.9, label: '6.0° S' },
			{ lat: -6.5, label: '6,5° S' },
			{ lat: -7.0, label: '7,0° S' },
			{ lat: -7.5, label: '7,5° S' },
			{ lat: -8.0, label: '8,0° S' },
			{ lat: -8.4, label: '' },
		],
		eixoHorizontal: [
			//{ lng: -39.0, label: '39.0° W' },//
			{ lng: -38.5, label: '38,5° W' },
			{ lng: -38.0, label: '38,0° W' },
			{ lng: -37.5, label: '37.5° W' },
			{ lng: -37.0, label: '37,0° W' },
			{ lng: -36.5, label: '36,5° W' },
			{ lng: -36.0, label: '36,0° W' },
			{ lng: -35.5, label: '35,5° W' },
			{ lng: -35.0, label: '35,0° W' },
			//{ lng: -34.5, label: '34,75° W' },//
		],
	};
	descricaoRelatorio =
		'Define-se como IAPM, Índice de Anomalia de Precipitação Modificado, a variação da pluviometria em comparação com valores médios históricos a fim de caracterizar as diferentes intensidades de eventos secos e chuvosos no tempo e no espaço.';

	referenciaEstudo =
		'Os métodos utilizados para a análise da precipitação e cálculo do Índice de Anomalia de Chuva (IAC) foram baseados no estudo intitulado: "Índice de Anomalia de Chuva (IAC) como Indicador para Análise da Variabilidade Climática na Bacia Hidrográfica do Rio Pajeú-PE", de autoria de J. M. O. Assis, W. M. Souza, M. C. M. Sobral, G. L. Melo e R. A. Irmão. Este trabalho foi apresentado no XX Simpósio Brasileiro de Recursos Hídricos em 2013 e fornece uma aplicação prática do IAC para a análise da variabilidade climática. O estudo está disponível no repositório da Associação Brasileira de Recursos Hídricos (ABRHidro).';

	periodoTitulo = '';
	relatorioService = inject(RelatoriosService);

	botoesDeExportacao: GroupButton[] = [
		{
			label: '.png',
			size: 'small',
			icon: 'ph-image',
			onClick: async () => {
				try {
					this.mapa?.resetMapView();
				} catch {}
				await this.exportarPNG(
					`Índice de anomalia de precipitação modificado (IAPM) - ${this.periodoTitulo}`,
					250
				);
			},
		},

		{
			label: '.pdf',
			size: 'small',
			icon: 'ph-file-pdf',
			activeFakeLoading: true,
			onClick: () => {
				if (this.mapa) {
					this.mapa.resetMapView();
				}
				setTimeout(() => {
					return this.exportarPDF();
				}, 1000);
			},
		},
		{
			label: '.csv',
			size: 'small',
			icon: 'ph-file-csv',
			onClick: () => this.exportarCSV(),
		},
		{
			label: '.txt',
			size: 'small',
			icon: 'ph-file-text',
			onClick: () => this.exportarTXT(),
		},
		{
			label: '.xlsx',
			size: 'small',
			icon: 'ph-file-xls',
			onClick: () => this.exportarXLSX(),
		},
	];

	constructor(
		private httpClient: HttpClient,
		private graficosPrecipitacaoService: GraficosPrecipitacaoService,
		private toastr: ToastrService
	) {
		this.setValidators();
	}

	@HostListener('window:resize')
	onResize() {
		const map = this.getLeafletMap();
		if (map) {
			setTimeout(() => map.invalidateSize(), 120);
		}
	}

	ngOnInit() {
		const dataAtual = new Date();
		const inicioDefault = startOfMonth(subMonths(dataAtual, 7));
		const fimDefault = endOfMonth(subMonths(dataAtual, 1));

		this.periodoTitulo = DateTimeUtils.formatarDataPeriodo(
			inicioDefault,
			fimDefault,
			'diario'
		);

		this.inputs.form.patchValue({
			dataInicio: inicioDefault,
			dataFim: fimDefault,
		});

		this.initialValues();
	}

	ngOnDestroy() {
		this.inputs.form.get(FormularioRelatorio.DATA_INICIO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.DATA_FIM)?.clearValidators();
	}

	initialValues() {
		const pbGeoJsonObservable = this.httpClient.get<FeatureCollection>(
			'assets/geoJson/pb-geo.json'
		);
		pbGeoJsonObservable.subscribe(value => {
			this.regiao = (<Polygon>value.features[0].geometry)
				.coordinates as Position[][];
			this.pbGeo = value as unknown as GeoJsonObject;
		});
	}

	setValidators() {
		this.inputs.form
			.get(FormularioRelatorio.DATA_INICIO)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.DATA_FIM)
			?.setValidators(Validators.required);
	}

	gerarRelatorio() {
		if (this.inputs.form.invalid) {
			return;
		}

		const dataInicio = this.inputs.form.get('dataInicio')?.value;
		const dataFim = this.inputs.form.get('dataFim')?.value;

		if (!dataInicio || !dataFim || !this.postos.length) {
			return;
		}

		this.inputs.setLoading(true);
		this.carregando = true;
		this.periodoTitulo = DateTimeUtils.formatarDataPeriodo(
			dataInicio,
			dataFim,
			'diario'
		);

		this.graficosPrecipitacaoService
			.buscarIAPM(formatISO(new Date(dataInicio)), formatISO(new Date(dataFim)))
			.subscribe({
				next: (resp: Iapm[]) => {
					const collator = new Intl.Collator('pt-BR', {
						sensitivity: 'base',
						numeric: true,
					});
					resp.sort((a: Iapm, b: Iapm) => {
						const nomeA = a.municipio ?? a.nomePosto;
						const nomeB = b.municipio ?? b.nomePosto;
						return collator.compare(nomeA, nomeB);
					});
					this.relatorioService.atualizaVisibilidadeBotoesExportacao(resp);
					this.medicoes = resp;
				},
				error: erro => {
					this.carregando = false;
					this.inputs.setLoading(false);
					const msg_erro = obter_erro_request(erro);
					this.toastr.error(msg_erro, 'Erro ao obter informações de IAPM');
				},
				complete: () => {
					this.interpolarValores();
					this.carregando = false;
					this.inputs.setLoading(false);
				},
			});
	}

	async interpolarValores() {
		try {
			const [interpolacaoPrecipitacao, interpolacaoIAPM] = await Promise.all([
				this.criarImagemInterpolacao('precipitacao1Mes', true),
				this.criarImagemInterpolacao('mrai', false),
			]);

			this.interpolacaoPrecipitacao =
				interpolacaoPrecipitacao as InterpolacaoCanvasBounds;
			this.interpolacaoIAPM = interpolacaoIAPM as InterpolacaoCanvasBounds;
		} catch (error) {
			console.error('Erro ao interpolar valores:', error);
		}
	}

	valoresParaInterpolacao(isPrecipitacao: boolean) {
		return this.medicoes.map(value => ({
			lat: value.latitude,
			lng: value.longitude,
			value: isPrecipitacao ? value.acumulado : value.mrai,
			nomePosto: value.nomePosto,
			isPrecipitacao: isPrecipitacao,
		}));
	}
	criarImagemInterpolacao(
		variavel: VariavelMeteorologica,
		isPrecipitacao: boolean
	): Promise<InterpolacaoCanvasBounds> {
		return new Promise((resolve, reject) => {
			const interpolacao = criarCanvasInterpolacao(
				this.valoresParaInterpolacao(isPrecipitacao),
				variavel,
				this.regiao as number[][][],
				0.01,
				true
			);
			if (interpolacao === undefined || interpolacao === null) {
				reject(`Erro ao criar imagem de interpolação de ${variavel}.`);
			}
			resolve(interpolacao);
		});
	}

	getDadosTabelaParaExportacao(dados: Iapm[], isPdf: boolean) {
		const tableData: any[][] = [];

		const colunas = [
			{ text: 'Município/Posto', fillColor: '#DCDCDC', alignment: 'center' },
			{ text: 'Latitude', fillColor: '#DCDCDC', alignment: 'center' },
			{ text: 'Longitude', fillColor: '#DCDCDC', alignment: 'center' },
			{ text: 'Altitude', fillColor: '#DCDCDC', alignment: 'center' },
			{
				text: 'Pluviometria observada (mm)',
				fillColor: '#DCDCDC',
				alignment: 'center',
			},
			{ text: 'IAPM', fillColor: '#DCDCDC', alignment: 'center' },
			{ text: 'Classificação', fillColor: '#DCDCDC', alignment: 'center' },
		];

		verificaSePDFEAdicionaNaTabela(tableData, colunas, isPdf);

		dados.forEach((item: Iapm) => {
			const rowData = [
				corrigeDuplicacaoNome(`${item.municipio}/${item.nomePosto}`),
				alinharDado(numberToBrNumberTables(item.latitude, 4), isPdf),
				alinharDado(numberToBrNumberTables(item.longitude, 4), isPdf),
				alinharDado(numberToBrNumberTables(item.altitude, 1), isPdf),
				alinharDado(numberToBrNumberTables(item.acumulado, 1), isPdf),
				alinharDado(numberToBrNumberTables(item.mrai, 1), isPdf),
				alinharDado(item.classificacao, isPdf),
			];
			tableData.push(rowData);
		});

		return tableData;
	}

	retornarIAPMParaXLSX() {
		const iapms: IapmComStrings[] = [];

		this.medicoes.forEach(iapm => {
			iapms.push({
				estacaoId: iapm.estacaoId,
				nomePosto: corrigeDuplicacaoNome(`${iapm.municipio}/${iapm.nomePosto}`),
				municipio: iapm.municipio,
				latitude: isNuloOuUndefined(iapm.latitude)
					? '-'
					: NumberUtils.getIgnorandoCasasDecimais(iapm.latitude, 4),
				longitude: isNuloOuUndefined(iapm.longitude)
					? '-'
					: NumberUtils.getIgnorandoCasasDecimais(iapm.longitude, 4),
				altitude: isNuloOuUndefined(iapm.altitude)
					? '-'
					: NumberUtils.getIgnorandoCasasDecimais(iapm.altitude),
				acumulado: isNuloOuUndefined(iapm.acumulado)
					? '-'
					: NumberUtils.getIgnorandoCasasDecimais(iapm.acumulado),
				mrai: isNuloOuUndefined(iapm.mrai)
					? '-'
					: NumberUtils.getIgnorandoCasasDecimais(iapm.mrai),
				classificacao: iapm.classificacao,
			});
		});
		return iapms;
	}

	async exportarPDF() {
		format(new Date(), "dd 'de' MMMM 'de' yyyy HH'h'mm", {
			locale: ptBrLocale,
		});
		const documentDefinition: any = await pdfseira.documentDefinitions();
		const capture = await this.getMapImage();
		const img = capture?.dataUrl;

		if (!img) {
			this.toastr.error('Não foi possível capturar o mapa para PDF.');
			return;
		}

		const { dataUrl: dataUrlFinal } = await this.montarMapaComLogos(capture, {
			showHeader: false,
			offsetY: 0,
			showPeriodo: false,
		});

		documentDefinition.content.push([
			{
				text: `Índice de anomalia de precipitação modificado (IAPM) - ${this.periodoTitulo}`,
				alignment: 'center',
				margin: [0, 15, 5, 15],
			},
			{
				image: dataUrlFinal,
				fit: [500, 400],
				alignment: 'center',
			},
		]);

		const tableData = this.getDadosTabelaParaExportacao(this.medicoes, true);

		documentDefinition.content.push({
			table: {
				widths: ['18%', '13%', '13%', '13%', '15%', '10%', '20%'],
				body: tableData,
				layout: {
					noWrap: false,
					fontSize: 5,
				},
			},
			marginLeft: 0,
			marginRight: 10,
		});

		baixarEAbrirPDF(
			`Índice de anomalia de precipitação modificado (IAPM) - ${this.periodoTitulo}`,
			documentDefinition
		);
	}

	exportarCSV() {
		const tableData = this.getDadosTabelaParaExportacao(this.medicoes, false);

		DocumentExporter.gerarCSV(
			tableData,
			`Índice de anomalia de precipitação modificado (IAPM) - ${this.periodoTitulo}`
		);
	}

	exportarTXT() {
		const tableData = this.getDadosTabelaParaExportacao(this.medicoes, false);

		let txtData = '';
		if (tableData.length > 0) {
			const colunas = tableData[0];

			tableData.slice(1).forEach(dadoRelatorio => {
				colunas.forEach((coluna: string, index: number) => {
					const valor = dadoRelatorio[index];
					txtData += `${coluna}: ${valor ?? '-'}\n`;
				});

				txtData += '\n';
			});
		}

		DocumentExporter.gerarTXT(
			txtData,
			`Índice de anomalia de precipitação modificado (IAPM) - ${this.periodoTitulo}`
		);
	}

	exportarXLSX() {
		const nomeArquivo = `Índice de anomalia de precipitação modificado (IAPM) - ${this.periodoTitulo}`;

		const colorPalette = {
			c1: '2C3639',
			c2: 'FFFFFF',
			c3: '000000',
			c4: 'EEEEEE',
		};

		const rowStyle = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
		};
		const headerStyle = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
		};
		const headerStyleCenter = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const rowStyleCenter = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};

		const title = {
			backgroundColor: colorPalette.c2,
			whiteSpace: 'pre',
			color: colorPalette.c3,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
				wrapText: 1,
			} as ExcelTable.DataModel.AlignmentOption,
		};

		const headers = [
			{
				label: 'nomePosto',
				text: 'Município/Posto',
				size: 48,
			},
			{ label: 'latitude', text: 'Latitude', size: 24 },
			{ label: 'longitude', text: 'Longitude', size: 24 },
			{ label: 'altitude', text: 'Altitude', size: 24 },
			{ label: 'acumulado', text: 'Pluviometria observada (mm)', size: 24 },
			{ label: 'mrai', text: 'IAPM', size: 24 },
			{ label: 'classificacao', text: 'Classificação', size: 24 },
		];
		const dataExcel = {
			styles: {
				headerStyle,
				headerStyleCenter,
				rowStyle,
				rowStyleCenter,
				title,
			},
			sheet: [
				{
					shiftTop: 3,
					images: [
						{
							url: 'assets/images/cabecalho/cabeçalho_excel.png',
							from: 'A1',
							to: 'C3',
						},
					],
					styleCellCondition(
						data: any,
						object: any,
						rowIndex: number,
						colIndex: number
					) {
						if (data && data.label) {
							return 'headerStyleCenter';
						} else if (colIndex > 0) {
							return 'rowStyleCenter';
						} else {
							return 'rowStyle';
						}
					},
					headers: headers,
					data: this.retornarIAPMParaXLSX(),
					columns: [
						{ key: 'nomePosto' },
						{
							key: 'latitude',
							style: { numFmt: '0.0' },
						},
						{
							key: 'longitude',
							style: { numFmt: '0.0' },
						},
						{
							key: 'altitude',
							style: { numFmt: '0.0' },
						},
						{
							key: 'acumulado',
							style: { numFmt: '0' },
						},
						{
							key: 'mrai',
							style: { numFmt: '0' },
						},
						{
							key: 'classificacao',
						},
					],
					title: {
						consommeRow: 3,
						consommeCol: 3,
						text: `${nomeArquivo}`,
						styleId: 'title',
					},
				},
			],
			fileName: nomeArquivo,
		};

		ExcelTable.generateExcel(dataExcel);
	}

	private async getWrapperPng(containerId = 'mapa-legenda', delayMs = 200) {
		try {
			this.mapa?.resetMapView();
		} catch {}

		await new Promise(r => setTimeout(r, delayMs));

		const el = document.getElementById(containerId);
		if (!el) return null;

		const mapCol = el.querySelector('.vh-100') as HTMLElement | null;
		const prevClass = mapCol?.className ?? '';
		const prevStyle = mapCol?.getAttribute('style') ?? '';

		if (mapCol) {
			mapCol.className = prevClass.replace(/\bvh-100\b/, '').trim();
			mapCol.setAttribute(
				'style',
				prevStyle.replace(/max-height:\s*500px;?/i, '').trim()
			);
		}

		const canvas = await html2canvas(el, {
			useCORS: true,
			allowTaint: true,
			logging: false,
			scale: 2,
		});

		if (mapCol) {
			mapCol.className = prevClass;
			mapCol.setAttribute('style', prevStyle);
		}

		return canvas.toDataURL('image/png', 1);
	}

	async getMapImage(): Promise<{
		dataUrl: string;
		mapRect: { x: number; y: number; w: number; h: number };
		canvasW: number;
		canvasH: number;
	} | null> {
		const root = document.getElementById('mapa-legenda');
		const map = this.getLeafletMap();

		if (!root || !map) return null;

		this.isExporting = true;
		root.classList.add('export-mode');
		let restoreMobileLayout: (() => void) | null = null;
		const controlesParaOcultar = Array.from(
			root.querySelectorAll(
				'.leaflet-control-zoom, .leaflet-control-container .leaflet-bar, .leaflet-control-container button'
			)
		) as HTMLElement[];

		const estadosOriginais = controlesParaOcultar.map(el => ({
			el,
			display: el.style.display,
		}));

		controlesParaOcultar.forEach(el => {
			el.style.display = 'none';
		});

		this.aplicarContornoComoObservada();
		this.aplicarOverlaysSomenteNaExportacao(map);

		try {
			restoreMobileLayout = await this.ajustarLayoutMobileParaExportacao(
				root,
				map
			);
			await this.esperarRenderizacaoMapa();
			await new Promise(resolve => setTimeout(resolve, 500)); // Delay extra para overlays

			const canvas = await html2canvas(root, {
				useCORS: true,
				allowTaint: true,
				logging: false,
				scale: this.exportScale,
				windowWidth: this.isMobileViewport()
					? this.exportDesktopWidth
					: window.innerWidth,
			});

			const leafletEl = root.querySelector(
				'.leaflet-container'
			) as HTMLElement | null;
			if (!leafletEl) return null;

			const rootRect = root.getBoundingClientRect();
			const mapRectDom = leafletEl.getBoundingClientRect();

			const relLeft = mapRectDom.left - rootRect.left;
			const relTop = mapRectDom.top - rootRect.top;

			return {
				dataUrl: canvas.toDataURL('image/png', 1),
				canvasW: canvas.width,
				canvasH: canvas.height,
				mapRect: {
					x: relLeft * this.exportScale,
					y: relTop * this.exportScale,
					w: mapRectDom.width * this.exportScale,
					h: mapRectDom.height * this.exportScale,
				},
			};
		} finally {
			if (restoreMobileLayout) restoreMobileLayout();
			this.isExporting = false;
			root.classList.remove('export-mode');
			estadosOriginais.forEach(({ el, display }) => {
				el.style.display = display;
			});
			this.aplicarContornoComoObservada();
			this.removerOverlaysDaExportacao();
		}
	}

	public async exportarPNG(nomeArquivo?: string, delayMs = 200) {
		await new Promise(r => setTimeout(r, 750));

		const capture = await this.getMapImage();
		if (!capture) {
			console.error('Não foi possível capturar a imagem do mapa.');
			return;
		}

		const nome =
			nomeArquivo ??
			`Índice de anomalia de precipitação modificado (IAPM) - ${this.periodoTitulo}`;

		try {
			const isMobile = this.isMobileViewport();
			const offsetY = isMobile ? 300 : 280;
			const cropPad = isMobile
				? { bottom: 140, top: 170, left: 20, right: 40 }
				: { bottom: 280, top: 130, left: 40, right: 40 };

			const { dataUrl: dataUrlFinal } = await this.montarMapaComLogos(capture, {
				showPeriodo: true,
				periodoYOffset: 2,
				showHeader: true,
				offsetY,
			});

			const recortado = await this.recortarDataUrlSides(
				dataUrlFinal,
				isMobile
					? {
							x: 0,
							y: offsetY,
							w: capture.canvasW,
							h: capture.canvasH,
						}
					: {
							x: capture.mapRect.x,
							y: offsetY + capture.mapRect.y,
							w: capture.mapRect.w,
							h: capture.mapRect.h,
						},
				cropPad
			);

			this.downloadDataUrl(nome, recortado);
		} catch (e) {
			console.error('[Export PNG] Erro ao recortar:', e);
			this.downloadDataUrl(nome, capture.dataUrl);
		}
	}
	private downloadDataUrl(filename: string, dataUrl: string) {
		const a = document.createElement('a');
		a.href = dataUrl;
		a.download = filename + '.png';
		a.style.display = 'none';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	private carregarImagem(src: string): Promise<HTMLImageElement> {
		return new Promise((resolve, reject) => {
			const image = new Image();
			image.crossOrigin = 'anonymous';
			image.onload = () => resolve(image);
			image.onerror = err => reject(err);
			image.src = src;
		});
	}

	private async recortarDataUrlSides(
		dataUrl: string,
		rect: { x: number; y: number; w: number; h: number },
		pad: { top?: number; right?: number; bottom?: number; left?: number } = {}
	): Promise<string> {
		const img = await this.carregarImagem(dataUrl);

		const top = pad.top ?? 0;
		const right = pad.right ?? 0;
		const bottom = pad.bottom ?? 10;
		const left = pad.left ?? 0;

		const sx = Math.max(0, Math.floor(rect.x - left));
		const sy = Math.max(0, Math.floor(rect.y - top));
		const sw = Math.min(
			img.naturalWidth - sx,
			Math.floor(rect.w + left + right)
		);
		const sh = Math.min(
			img.naturalHeight - sy,
			Math.floor(rect.h + top + bottom)
		);

		const out = document.createElement('canvas');
		out.width = sw;
		out.height = sh;

		const ctx = out.getContext('2d')!;
		ctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);

		return out.toDataURL('image/png', 1);
	}

	private resolveAsset(path: string) {
		return new URL(path, document.baseURI).toString();
	}

	private async montarMapaComLogos(
		capture: {
			dataUrl: string;
			mapRect: { x: number; y: number; w: number; h: number };
			canvasW: number;
			canvasH: number;
		},
		opts?: {
			showPeriodo?: boolean;
			periodoYOffset?: number;
			showHeader?: boolean;
			offsetY?: number;
		}
	): Promise<{ dataUrl: string; headerH: number }> {
		const showPeriodo = opts?.showPeriodo ?? false;
		const periodoYOffset = opts?.periodoYOffset ?? 0;

		const showHeader = opts?.showHeader ?? true;
		const offsetY = opts?.offsetY ?? 200;
		const logoGovernoSrc = this.resolveAsset(
			'assets/images/logos/governo_pb.png'
		);
		const logoAesaSrc = this.resolveAsset('assets/images/logos/logoAesa.svg');

		const results = await Promise.allSettled([
			this.carregarImagem(capture.dataUrl),
			this.carregarImagem(logoGovernoSrc),
			this.carregarImagem(logoAesaSrc),
		]);

		const mapImage =
			results[0].status === 'fulfilled' ? results[0].value : null;
		const logoGov = results[1].status === 'fulfilled' ? results[1].value : null;
		const logoAesa =
			results[2].status === 'fulfilled' ? results[2].value : null;

		if (!mapImage) return { dataUrl: capture.dataUrl, headerH: 0 };

		const canvas = document.createElement('canvas');
		canvas.width = mapImage.naturalWidth;
		canvas.height = mapImage.naturalHeight + offsetY;

		const ctx = canvas.getContext('2d')!;
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, canvas.width, canvas.height);

		ctx.drawImage(mapImage, 0, offsetY);

		ctx.fillStyle = '#ffffff';

		const mapX0 = capture.mapRect.x;
		const mapY0 = offsetY + capture.mapRect.y;
		const mapX1 = mapX0 + capture.mapRect.w;

		const insidePad = 75;
		const maxLogoHInside = Math.round(Math.min(70, capture.mapRect.h * 0.12));

		const drawLogoInside = (imgEl: HTMLImageElement, x: number, y: number) => {
			const ratio = imgEl.naturalWidth / imgEl.naturalHeight;
			const h = maxLogoHInside;
			const w = Math.round(h * ratio);

			ctx.closePath();
			ctx.fill();
			ctx.stroke();
			ctx.restore();

			ctx.drawImage(imgEl, x, y, w, h);
		};

		const mapY1 = mapY0 + capture.mapRect.h;

		const hLogo = maxLogoHInside;

		const isMobile = this.isMobileViewport();
		const logoDy = isMobile ? -40 : -130;

		const govDx = 90;
		const govDy = logoDy;

		const aesaDx = -105;
		const aesaDy = logoDy;

		if (logoAesa) {
			drawLogoInside(
				logoAesa,
				mapX0 + insidePad + govDx,
				mapY1 - insidePad - hLogo + govDy
			);
		}

		if (logoGov) {
			const wG = Math.round(
				hLogo * (logoGov.naturalWidth / logoGov.naturalHeight)
			);
			drawLogoInside(
				logoGov,
				mapX1 - insidePad - wG + aesaDx,
				mapY1 - insidePad - hLogo + aesaDy
			);
		}

		let headerH = 0;
		if (showHeader) {
			headerH = Math.max(52, Math.min(90, Math.round(canvas.height * 0.085)));

			ctx.save();
			ctx.fillStyle = 'rgba(255,255,255,0.92)';
			ctx.fillRect(0, 0, canvas.width, headerH);

			ctx.strokeStyle = 'rgba(17,24,39,0.12)';
			ctx.lineWidth = 1;
			ctx.beginPath();
			ctx.moveTo(0, headerH - 0.5);
			ctx.lineTo(canvas.width, headerH - 0.5);
			ctx.stroke();

			const titulo = 'Índice de anomalia de precipitação modificado (IAPM)';
			const periodo = this.periodoTitulo ?? '';

			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			const font1 = Math.max(24, Math.min(36, Math.round(headerH * 0.5)));
			const font2 = Math.max(24, Math.min(36, Math.round(headerH * 0.5)));

			ctx.fillStyle = '#111827';
			ctx.font = `700 ${font1}px Poppins, Arial, sans-serif`;
			// título
			ctx.font = `700 ${font1}px Poppins, Arial, sans-serif`;
			const titleYOffset = isMobile ? 18 : 0;
			ctx.fillText(titulo, canvas.width / 2, headerH * 2.8 + titleYOffset - 6);

			// período (se quiser)
			if (showPeriodo && periodo.trim()) {
				ctx.font = `600 ${font2}px Poppins, Arial, sans-serif`;
				ctx.fillText(
					periodo,
					canvas.width / 2,
					headerH * 3.3 + titleYOffset + (periodoYOffset ?? 0) - 6
				);
			}

			ctx.restore();
		}

		return { dataUrl: canvas.toDataURL('image/png', 1), headerH };
	}

	private async ajustarLayoutMobileParaExportacao(
		root: HTMLElement,
		map: Leaflet.Map
	): Promise<(() => void) | null> {
		if (!this.isMobileViewport()) return null;

		const mapaWrapper = root.querySelector(
			'.mapa-wrapper'
		) as HTMLElement | null;
		const mapaLeaflet = root.querySelector(
			'.leaflet-container'
		) as HTMLElement | null;

		const rootPrev = {
			width: root.style.width,
			minWidth: root.style.minWidth,
			maxWidth: root.style.maxWidth,
		};

		const wrapperPrev = mapaWrapper
			? {
					height: mapaWrapper.style.height,
					minHeight: mapaWrapper.style.minHeight,
				}
			: null;

		const leafletPrev = mapaLeaflet
			? {
					height: mapaLeaflet.style.height,
				}
			: null;

		const originalCenter = map.getCenter();
		const originalZoom = map.getZoom();
		const originalMinZoom = map.getMinZoom();
		const originalMaxZoom = map.getMaxZoom();

		root.style.width = `${this.exportDesktopWidth}px`;
		root.style.minWidth = `${this.exportDesktopWidth}px`;
		root.style.maxWidth = `${this.exportDesktopWidth}px`;

		if (mapaWrapper) {
			mapaWrapper.style.height = `${this.exportMapHeight}px`;
			mapaWrapper.style.minHeight = `${this.exportMapHeight}px`;
		}

		if (mapaLeaflet) {
			mapaLeaflet.style.height = `${this.exportMapHeight}px`;
		}

		map.setMinZoom(6);
		map.setMaxZoom(19);
		map.setView(
			MapaInterpolacaoComponent.COORDENADAS_PADRAO,
			MapaInterpolacaoComponent.ZOOM_PADRAO
		);
		map.invalidateSize(true);
		await this.esperarRenderizacaoMapa();

		return () => {
			root.style.width = rootPrev.width;
			root.style.minWidth = rootPrev.minWidth;
			root.style.maxWidth = rootPrev.maxWidth;

			if (mapaWrapper && wrapperPrev) {
				mapaWrapper.style.height = wrapperPrev.height;
				mapaWrapper.style.minHeight = wrapperPrev.minHeight;
			}

			if (mapaLeaflet && leafletPrev) {
				mapaLeaflet.style.height = leafletPrev.height;
			}

			map.setMinZoom(originalMinZoom);
			map.setMaxZoom(originalMaxZoom);
			map.setView(originalCenter, originalZoom);
			map.invalidateSize(true);
		};
	}

	private async esperarRenderizacaoMapa(): Promise<void> {
		return new Promise(resolve => {
			const map = this.getLeafletMap();
			if (!map) {
				resolve();
				return;
			}

			let resolved = false;
			const check = () => {
				if (resolved) return;
				resolved = true;
				resolve();
			};

			map.once('render', check);
			setTimeout(check, 1500); // Aumentado de 1000 para 1500
		});
	}
	private getLeafletMap(): Leaflet.Map | null {
		return this.mapa?.mapa ?? null;
	}

	private aplicarContornoComoObservada() {
		const map = this.getLeafletMap();
		if (!map || !this.pbGeo) return;

		if (!map.getPane(this.contornoPaneName)) {
			map.createPane(this.contornoPaneName);
			const pane = map.getPane(this.contornoPaneName)!;
			pane.style.zIndex = '450';
			pane.style.pointerEvents = 'none';
		}

		if (this.outlineLayer) {
			this.outlineLayer.remove();
			this.outlineLayer = undefined;
		}

		const strokeColor = '#111827';
		const strokeOpacity = this.isExporting ? 0.85 : 0.7;

		this.outlineLayer = Leaflet.geoJSON(this.pbGeo as any, {
			pane: this.contornoPaneName,
			interactive: false,
			style: () => ({
				color: strokeColor,
				opacity: strokeOpacity,
				weight: this.isExporting ? 1.4 : 1.0,
				fill: false,
				fillOpacity: 0,
				lineJoin: 'round',
				lineCap: 'round',
			}),
		}).addTo(map);

		if ((this.outlineLayer as any)?.bringToFront) {
			(this.outlineLayer as any).bringToFront();
		}
	}

	private aplicarCoordenadas(map: Leaflet.Map) {
		if (this.coordOverlayEl) this.coordOverlayEl.remove();
		if (this.coordOverlayCleanup) this.coordOverlayCleanup();

		const container = map.getContainer() as HTMLElement;
		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		const overlay = document.createElement('div');
		overlay.className = 'mapa-coordenadas-overlay';
		overlay.style.position = 'absolute';
		overlay.style.inset = '0';
		overlay.style.pointerEvents = 'none';
		overlay.style.overflow = 'hidden';
		overlay.style.zIndex = '9999';

		container.appendChild(overlay);
		this.coordOverlayEl = overlay;

		const render = () => {
			const b = this.getGeoJsonBounds();
			if (!b) return;
			this.renderizarCoordenadasNoMapa(map, b);
		};

		map.whenReady(() => render());
		map.on('resize', render);
		map.on('moveend', render);
		map.on('zoomend', render);

		this.coordOverlayCleanup = () => {
			map.off('resize', render);
			map.off('moveend', render);
			map.off('zoomend', render);
		};
	}

	private renderizarCoordenadasNoMapa(
		map: Leaflet.Map,
		_bounds?: Leaflet.LatLngBounds
	) {
		if (!this.coordOverlayEl) return;

		const size = map.getSize();
		if (!size || size.x < 50 || size.y < 50) return;

		const b = _bounds ?? map.getBounds();
		const center = b.getCenter();

		const gutterLeft = 74;
		const padTop = 14;
		const padRight = 84;

		const axisX = gutterLeft;
		const axisTop = padTop;
		const axisRight = size.x - padRight;

		const latBaseEixoX =
			this.coordenadasRef.eixoVertical[
				this.coordenadasRef.eixoVertical.length - 1
			]?.lat ?? -8.39;

		const yBaseRaw = map.latLngToContainerPoint([latBaseEixoX, center.lng]).y;
		const lineColor = this.isExporting ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,.28)';
		const textColor = this.isExporting ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,.55)';

		const fontSize = 12;
		const tickLen = 10;

		const gap = 3;

		const maxAxisY = size.y - (tickLen + 18);
		const minAxisY = axisTop + 40;

		const axisY = Math.round(Math.min(maxAxisY, Math.max(minAxisY, yBaseRaw)));

		const eixoLinhas = `
  <!-- esquerda -->
  <div style="
    position:absolute;
    left:${axisX}px;
    top:${axisTop}px;
    width:1px;
    height:${Math.max(0, axisY - axisTop)}px;
    background:${lineColor};
  "></div>

  <!-- baixo -->
  <div style="
    position:absolute;
    left:${axisX}px;
    top:${axisY}px;
    height:1px;
    width:${Math.max(0, axisRight - axisX)}px;
    background:${lineColor};
  "></div>

  <!-- cima (NOVO) -->
  <div style="
    position:absolute;
    left:${axisX}px;
    top:${axisTop}px;
    height:1px;
    width:${Math.max(0, axisRight - axisX)}px;
    background:${lineColor};
  "></div>

  <!-- direita (NOVO) -->
  <div style="
    position:absolute;
    left:${axisRight}px;
    top:${axisTop}px;
    width:1px;
    height:${Math.max(0, axisY - axisTop)}px;
    background:${lineColor};
  "></div>
`;

		const ticksY = this.coordenadasRef.eixoVertical
			.map(t => {
				const yRaw = map.latLngToContainerPoint([t.lat, center.lng]).y;
				if (yRaw < axisTop - 80 || yRaw > axisY + 80) return '';

				const y = Math.round(Math.min(axisY, Math.max(axisTop, yRaw)));

				const xLabel = axisX - tickLen - gap;

				return `
      <!-- label (wrapper posiciona; filho rotaciona) -->
      <div style="
        position:absolute;
        left:${xLabel}px;
        top:${y}px;
        transform: translate(-100%,-50%);
        color:${textColor};
        font-size:${fontSize}px;
        line-height:1;
        white-space:nowrap;
      ">
        <span style="
          display:inline-block;
          transform: rotate(-90deg);
          transform-origin: 100% 50%;
        ">${t.label}</span>
      </div>

      <!-- tick -->
      <div style="
        position:absolute;
        left:${axisX}px;
        top:${y}px;
        width:${tickLen}px;
        height:1px;
        background:${lineColor};
        transform:translateY(-50%);
      "></div>
    `;
			})
			.join('');

		const ticksX = this.coordenadasRef.eixoHorizontal
			.map((t: { lng: number; label: string }) => {
				const xRaw = map.latLngToContainerPoint([center.lat, t.lng]).x;

				if (xRaw < axisX - 80 || xRaw > axisRight + 80) return '';

				const x = Math.round(Math.min(axisRight, Math.max(axisX, xRaw)));

				return `
        <div style="
          position:absolute;
          left:${x}px;
          top:${axisY - tickLen}px;
          width:1px;
          height:${tickLen}px;
          background:${lineColor};
          transform:translateX(-50%);
        "></div>

        <div style="
          position:absolute;
          left:${x}px;
          top:${axisY + tickLen + -5}px;
          transform:translateX(-50%);
          color:${textColor};
          font-size:${fontSize}px;
          line-height:1;
          white-space:nowrap;
        ">${t.label}</div>
      `;
			})
			.join('');

		const midY = Math.round((axisTop + axisY) / 2);
		const midX = Math.round((axisX + axisRight) / 2);

		const titulosEixos = this.isExporting
			? `
		<!-- Latitude (eixo Y) -->
		<div style="
			position:absolute;
			left:${axisX - 30}px;
			top:${midY}px;
			transform: translate(-100%,-50%) rotate(-90deg);
			transform-origin: 100% 50%;
			color:${textColor};
			font-size:${fontSize + 2}px;
			font-weight:0;
			white-space:nowrap;
		">Latitude</div>

		<!-- Longitude (eixo X) -->
		<div style="
			position:absolute;
			left:${midX}px;
			top:${axisY + tickLen + 12}px;
			transform: translateX(-50%);
			color:${textColor};
			font-size:${fontSize + 2}px;
			font-weight:350;
			white-space:nowrap;
		">Longitude</div>
	`
			: '';

		this.coordOverlayEl.innerHTML = `${eixoLinhas}${ticksY}${ticksX}${titulosEixos}`;
	}

	private aplicarRosaDosVentos(map: Leaflet.Map) {
		if (this.compassOverlayEl) this.compassOverlayEl.remove();
		if (this.compassOverlayCleanup) this.compassOverlayCleanup();

		const container = map.getContainer() as HTMLElement;
		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		const overlay = document.createElement('div');
		overlay.className = 'mapa-rosa-dos-ventos-overlay';
		overlay.style.position = 'absolute';
		overlay.style.right = '95px';
		overlay.style.top = '30px';
		overlay.style.left = 'auto';
		overlay.style.width = '60px';
		overlay.style.height = '60px';
		overlay.style.pointerEvents = 'none';
		overlay.style.zIndex = '9999';

		container.appendChild(overlay);
		this.compassOverlayEl = overlay;

		const render = () => this.renderizarRosaDosVentos();
		map.whenReady(() => render());
		map.on('resize', render);

		this.compassOverlayCleanup = () => {
			map.off('resize', render);
		};
	}

	private renderizarRosaDosVentos() {
		if (!this.compassOverlayEl) return;

		const preto = '#111827';

		const cinza = '#9CA3AF';

		this.compassOverlayEl.innerHTML = `
			  <svg viewBox="0 0 100 100" width="60" height="60" style="display:block;">
			
				<!-- cÃ­rculo -->
				<circle cx="50" cy="52" r="32" fill="none" stroke="${cinza}" stroke-width="2"/>
			
				<!-- estrela (pontas principais) -->
				<polygon points="50,18 57,52 50,86 43,52"
				  fill="${cinza}"/>
				<polygon points="18,52 50,59 82,52 50,45"
				  fill="${cinza}"/>
			
				<!-- pontas diagonais (cinza) -->
				<polygon points="50,26 54,52 50,78 46,52"
				  fill="${cinza}" opacity="0.9" transform="rotate(45 50 52)"/>
			
				<!-- miolo -->
				<circle cx="50" cy="52" r="4" fill="${cinza}"/>
			
				<!-- letras (PT-BR) -->
				<text x="50" y="10" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">N</text>
			
				<text x="76" y="22" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">NE</text>
				<text x="24" y="22" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">NO</text>
			
				<text x="92" y="55" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">L</text>
				<text x="8"  y="55" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">O</text>
			
				<text x="76" y="92" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">SE</text>
				<text x="24" y="92" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">SO</text>
			
				<text x="50" y="99" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">S</text>
			  
			  </svg>
			  `;
	}

	private aplicarMascaraForaDoMapa(geo: GeoJsonObject, map: Leaflet.Map) {
		if (this.maskLayer) {
			this.maskLayer.remove();
			this.maskLayer = undefined;
		}

		if (!map.getPane(this.maskPaneName)) {
			map.createPane(this.maskPaneName);
			const pane = map.getPane(this.maskPaneName)!;
			pane.style.zIndex = '350';
			pane.style.pointerEvents = 'none';
		}

		const holes: Leaflet.LatLngExpression[][] = [];
		const addPolygonOuterRingAsHole = (coords: any) => {
			if (!Array.isArray(coords) || !Array.isArray(coords[0])) return;

			const ring = coords[0] as [number, number][];
			const latlngs: Leaflet.LatLngExpression[] = ring.map(([lng, lat]) => [
				lat,
				lng,
			]);
			holes.push(latlngs);
		};

		const g: any = geo;
		if (g?.type === 'FeatureCollection' && Array.isArray(g.features)) {
			for (const f of g.features) {
				const geom = f?.geometry;
				if (!geom) continue;

				if (geom.type === 'Polygon') {
					addPolygonOuterRingAsHole(geom.coordinates);
				} else if (geom.type === 'MultiPolygon') {
					for (const polyCoords of geom.coordinates) {
						addPolygonOuterRingAsHole(polyCoords);
					}
				}
			}
		}

		const outer: Leaflet.LatLngExpression[] = [
			[90, -180],
			[90, 180],
			[-90, 180],
			[-90, -180],
		];

		this.maskLayer = Leaflet.polygon([outer, ...holes], {
			pane: this.maskPaneName,
			stroke: false,
			fillColor: '#FFFFFF',
			fillOpacity: 1,
			interactive: false,
		}).addTo(map);
	}

	private removerCoordenadas() {
		if (this.coordOverlayEl) {
			this.coordOverlayEl.remove();
			this.coordOverlayEl = undefined;
		}
		if (this.coordOverlayCleanup) {
			this.coordOverlayCleanup();
			this.coordOverlayCleanup = undefined;
		}
	}

	private removerRosaDosVentos() {
		if (this.compassOverlayEl) {
			this.compassOverlayEl.remove();
			this.compassOverlayEl = undefined;
		}
		if (this.compassOverlayCleanup) {
			this.compassOverlayCleanup();
			this.compassOverlayCleanup = undefined;
		}
	}

	private removerMascara() {
		if (this.maskLayer) {
			this.maskLayer.remove();
			this.maskLayer = undefined;
		}
	}

	private getGeoJsonBounds(): Leaflet.LatLngBounds | null {
		if (!this.pbGeo) return null;
		const layer = Leaflet.geoJSON(this.pbGeo as any);
		return layer.getBounds();
	}

	private isMobileViewport(): boolean {
		return window.matchMedia('(max-width: 768px)').matches;
	}

	private aplicarOverlaysSomenteNaExportacao(map: Leaflet.Map) {
		if (this.pbGeo) {
			this.aplicarMascaraForaDoMapa(this.pbGeo, map);
		}

		this.aplicarCoordenadas(map);
		this.aplicarRosaDosVentos(map);
	}

	private removerOverlaysDaExportacao() {
		this.removerCoordenadas();
		this.removerRosaDosVentos();
		this.removerMascara();
	}
}
